import { createSelector } from '@ngrx/store';

import * as fromBase from './admin.selectors';

const selectClosuresState = createSelector(fromBase.selectAdminState, state => state.closures);

export const selectClosureProductsOdataResult = createSelector(selectClosuresState, state => state.closures);
export const selectClosureProducts = createSelector(selectClosureProductsOdataResult, odata => odata?.value);
export const selectClosureQuery = createSelector(selectClosuresState, state => state.closuresQuery);
export const selectClosureCurrentPage = createSelector(selectClosureQuery, q => q.skip === 0 ? 1 : Math.ceil((q.skip / q.top) + 1));
export const selectClosureAdminFilter = createSelector(selectClosuresState, state => state.closureAdminFilter);

export const selectCurrentlyEditing = createSelector(selectClosuresState, state => state.currentlyEditing);
export const selectCurrentlyEditingClosureId = createSelector(selectCurrentlyEditing, state => state.closureProduct?.id);
export const selectCurrentlyEditingClosure = createSelector(selectCurrentlyEditing, val => val?.closureProduct);
